import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Avatar, Box, Button, Divider, Drawer, Grid, Menu, Stack, Typography } from "@mui/material"
import React, { useState } from "react"
import { DateIcon } from '../../../assets/dateIcon'
import NoDataFound from '../../../assets/noData'
import { RescheduleDateIcon } from '../../../assets/rescheduleDate'
import { TrackClockIcon } from '../../../assets/trackClockIcon'
import { AlertDialog, DialogHeader, VerticalLinearStepper } from "../../../components"
import ReAssignModal from "../../../components/assignModal/reAssignModal"
import { AuthContext } from "../../../contexts"
import { RemoveZUTCDateTime, stringAvatar, useWindowDimensions } from '../../../utils'
import { useStyles } from "./style"
import { ViewServiceRequest } from "./viewServiceRequest"
import moment from 'moment'
import { TimeIcon } from '../../../assets/timeIcon'

export const RequestCard = ({ t = () => false, title = "", icon = "", image = "", subTitle = "", subTitle1 = "", backgroundColor = "#FFFFFF", status = "", assign = false, openAssignModal = () => false, unit_details = {}, date = {}, AllResources = [], agreement_inspection_id = "", reAssign = () => false, reAssignModal = false, setReAssignModal = () => false, maintenanceData = {}, rescheduleDetails = [], details = {} }) => {

    const classes = useStyles()
    const [isShow, setIsShow] = useState(false)
    const size = useWindowDimensions()
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const auth = React.useContext(AuthContext)

    // const handleClick = (event, title) => {
    //     setAnchorEl(event.currentTarget)
    //     setReqType(title)
    // }
    const handleClose = () => {
        setAnchorEl(null)
    }
    // const dialogHeader = () => {
    //     return (
    //         <Stack direction="row" spacing={1}>
    //             {/* <Box onClick={() => setReAssignModal(false)} className={classes.iconbtn} display="flex" alignItems="center">
    //                 <ArrowBackIosIcon className={classes.icon} htmlColor="black" />
    //             </Box> */}
    //             <Typography className={classes.dialoghdrtext}>{"Re-Assign Inspector"}</Typography>
    //         </Stack>
    //     )
    // }

    return (
        <Box className={classes.reqCardBlock} style={{ backgroundColor: backgroundColor, border: backgroundColor !== "#FFFFFF" && "none" }}>
            {assign ?
                <>
                    <center>
                        {icon}
                        <Typography className={classes.Name}>{t("Assign Resource & Date")}</Typography>
                        <Typography className={classes.subTitle}>{t("Schedule inspection date & assign resources vehicle, tools, helper, etc")}</Typography>
                        <Box mt={1}>
                            <Button variant="contained" onClick={openAssignModal}>{t("Assign")}</Button>
                        </Box>
                    </center>
                </> :
                <>
                    <Stack direction="row" justifyContent="space-between">
                        <Typography className={classes.title}>{title}</Typography>

                        <Box onClick={(event) => { (title === "Site Visit Request" || title === "Maintenance Request Details") ? setIsShow(true) : setAnchorEl(event.currentTarget) }}><Typography className={classes.viewMore}>{open ? t("View Less") : t("View More")}</Typography></Box>


                    </Stack>
                    {title === t("Resource Details") && rescheduleDetails?.length > 0 && rescheduleDetails?.[0]?.status !== "Pending" &&

                        <Box mt={1} className={rescheduleDetails?.[0]?.status === "Approved" ? classes.approvedinspection : classes?.reschedulesection} p={rescheduleDetails?.[0]?.status === "Approved" ? 2 : 0}>
                            {rescheduleDetails?.[0]?.status === "Approved" ?
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <>
                                        <CheckCircleIcon color="success" />
                                        <Typography className={rescheduleDetails?.[0]?.status === "Rescheduled" ? classes.rescheduletext : classes.approvedtext}>{rescheduleDetails?.[0]?.status === "Rescheduled" ? t("Reschedule requested") : t("Job Visit Approved")}</Typography>
                                    </>
                                </Stack>
                                :
                                <Grid container alignItems="center">
                                    <Grid item xs={12} sm={12} md={6} lg={4}>
                                        <center>
                                            <Box>
                                                <RescheduleDateIcon />
                                            </Box>
                                            <Box p={0.5}>
                                                <Typography className={classes.reschedulenewtext}>{t("Reschedule Requested")}</Typography>
                                            </Box>
                                        </center>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={8} sx={{ borderLeft: "1px solid #FF4B4B" }}>
                                        <Box p={1}>
                                            <Box>
                                                <Stack direction={"row"} spacing={0.5} alignItems="center">
                                                    <DateIcon />
                                                    <Typography className={classes.labeltxt}>{t("Date")}</Typography>
                                                </Stack>
                                                <Box mt={0.5}>
                                                    <Typography className={classes.valuetxt}>{moment(rescheduleDetails?.[0]?.rescheduled_datetime).format("DD MMM YY")}</Typography>
                                                </Box>
                                            </Box>
                                            {rescheduleDetails?.[0]?.slot_name?.length > 0 &&
                                                <Box mt={1}>
                                                    <Stack direction={"row"} spacing={0.5} alignItems="center">
                                                        <TimeIcon />
                                                        <Typography className={classes.labeltxt}>{t("Time")}</Typography>
                                                    </Stack>

                                                    <Box mt={0.5} className={classes.slotBox}>
                                                        <Typography className={classes.reschedulenewtext}>{rescheduleDetails?.[0]?.slot_name}</Typography>
                                                    </Box>

                                                </Box>
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </Box>
                    }
                    {title === "Resource Details" &&
                        <Box mt={1} mb={1} className={classes.resinspection} p={1}>
                            <Typography className={classes.insdateTime}>Inspection Date & Time</Typography>
                            {/* <Typography className={classes.insdateTime}>{moment(RemoveZUTCDateTime(date)).format("DD MMM YY , hh:mm A")}</Typography> */}
                            <Typography className={classes.insdateTime}>{RemoveZUTCDateTime(date, "DD MMM YY HH:mm A")}</Typography>

                        </Box>
                    }
                    <Box display="flex" alignItems="center" >

                        {image ?
                            <Box><Avatar src={AllResources?.[0]?.image_url} variant="square" className={classes.resimg} {...stringAvatar(subTitle)} /></Box>
                            : <Box marginTop="10px">{icon} </Box>
                        }


                        <Box flexGrow={1} marginInlineStart="12px">
                            <Typography className={classes.Name}>{subTitle}</Typography>
                            <Box height="2px" />
                            {subTitle1?.length > 0 &&
                                <Typography className={auth?.auth?.auth?.language === 'ar' ? classes.descriptionNo : classes.description}>{subTitle1}</Typography>
                            }
                        </Box>
                        {/* {status !== "Completed" && title ==="Inspection Detail" &&
                            <Box flexGrow={1} marginLeft="12px">
                                <Typography
                                    className={
                                        status === "Assigned"
                                            ? `${classes.Reassign}`
                                            : `${classes.status}`
                                    }
                                >
                                    {status}
                                </Typography>
                            </Box>
                        } */}


                    </Box>
                    {/* {status === "Completed" && title ==="Inspection Detail" &&
                        <center>
                            <Box mt={1} className={classes.completedDateTime}>
                                <Box><CheckIcon /></Box>
                                <Box ml={0.5}>
                                    <Typography className={classes.insdateTime}>Completed on 12 Dec 22</Typography>
                                </Box>
                            </Box>

                        </center>
                    } */}
                </>

            }
            <Menu
                id="simple-menu"
                className={classes.menuList}
                anchorEl={anchorEl}
                open={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{ sx: { width: "350px", backgroundColor: "white", border: "1px solid #E4E8EE", boxShadow: "0px 0px 16px #00000014" } }}
            >

                <Box>
                    <DialogHeader title={title} onClose={handleClose} />
                    {title === "Track Update" ?
                        <>

                            <Box p={2}>
                                {details?.length > 0 ?
                                    <VerticalLinearStepper data={details?.map((val) => { return { name: val?.title, created_by: val?.created_by, date: RemoveZUTCDateTime(val?.created_at, "DD-MM-YYYY hh:mm A"), icon: val.title === "Inspection Completed" ? <Box className={classes.checkIconcircle}><CheckCircleIcon color="primary" /></Box> : <TrackClockIcon />, notes: val?.description } })} customTrack />
                                    : <center>
                                        <NoDataFound />
                                    </center>}
                            </Box>
                        </>
                        : title === "Resource Details" ?
                            <>
                                <Box p={1.5} style={{ height: !["Completed", "Rejected"].includes(status) ? size?.height - 550 : "auto", overflow: "auto" }}>
                                    {AllResources?.length > 0 && AllResources?.map((x, i) => {
                                        return (
                                            <Box className={classes.reqCardBlock} style={{ backgroundColor: backgroundColor, border: backgroundColor !== "#FFFFFF" && "none" }} mb={1}>
                                                <Box display="flex" alignItems="center" >

                                                    {image ?
                                                        <Avatar variant="square" className={classes.resimg} src={x.image_url}  {...stringAvatar(x?.name)} />
                                                        : icon
                                                    }


                                                    <Box flexGrow={1} marginInlineStart="12px">
                                                        <Typography className={classes.Name}>{x.name}</Typography>
                                                        <Box height="2px" />
                                                        <Typography noWrap className={classes.mobileNo}>{`${x.mobile_no_country_code} ${x.mobile_no}`}</Typography>
                                                    </Box>
                                                    {/* <DeleteIcon /> */}

                                                </Box>
                                            </Box>
                                        )
                                    })}

                                </Box>
                                {!["Completed", "Rejected", "Yet To Verify"].includes(status) &&
                                    <Box mt={2} p={1.5}>
                                        <Button variant="contained" fullWidth onClick={() => { return (setReAssignModal(true), setAnchorEl(null)) }}>Add Resource</Button>
                                    </Box>
                                }
                            </>
                            :
                            <Box p={1.5} mt={-2}>


                                <Box display="flex" alignItems="center" >
                                    <Box marginTop="10px">
                                        {icon}
                                    </Box>
                                    <Box marginInlineStart="12px">
                                        <Typography className={classes.Name}>{subTitle}</Typography>
                                        <Box height="2px" />
                                        <Typography noWrap className={classes.description}>{subTitle1}</Typography>
                                    </Box>


                                </Box>
                                {/* <Box mt={1} mb={1}> <Divider className={classes.divStyle} /></Box>
                                <Box>
                                    <Typography className={classes.listText}>{"Tenant Details"}</Typography>
                                    <Stack direction={"row"} spacing={2} mt={1}>
                                        <Avatar />
                                        <Box>
                                            <Typography className={classes.Name}>{subTitle}</Typography>
                                            <Box height="2px" />
                                            <Typography noWrap className={classes.description}>{subTitle1}</Typography>
                                        </Box>
                                    </Stack>
                                </Box> */}
                                <Box mt={1} mb={1}> <Divider className={classes.divStyle} /></Box>
                                {unit_details?.unit_name &&
                                    <Box>
                                        <Typography className={classes.listText}>{t("Inspection Place")}</Typography>
                                        <Stack direction={"row"} mt={1} flexWrap={'wrap'}>
                                            <Avatar variant="square" className={classes.resimg} src={unit_details?.logo} {...stringAvatar(unit_details?.unit_name)} />
                                            <Box marginInlineStart="12px" >
                                                <Typography className={classes.Name}>{unit_details?.unit_no} / {unit_details?.unit_name} </Typography>
                                                <Box height="2px" />
                                                <Typography noWrap className={classes.location}>{unit_details?.property_name}</Typography>
                                                <Box height="2px" />
                                                <Box display="flex">
                                                    {unit_details?.street_1?.length > 0 &&
                                                        <Typography noWrap className={classes.address}>{unit_details?.street_1},</Typography>

                                                    }
                                                    {unit_details?.street_2?.length > 0 &&
                                                        <Typography noWrap className={classes.address}>{unit_details?.street_2},</Typography>
                                                    }
                                                    {unit_details?.city?.length > 0 &&
                                                        <Typography noWrap className={classes.address}>{unit_details?.city}</Typography>

                                                    } </Box>

                                            </Box>
                                        </Stack>
                                    </Box>
                                }
                            </Box>
                    }
                </Box>
            </Menu>

            <AlertDialog open={isShow}
                onClose={() => setIsShow(false)}
                header={title}
                isNormal={title === "Site Visit Request" && true}
                lg={title === "Maintenance Request Details" && true}
                component={
                    title === "Site Visit Request" ?
                        <Box p={2}>
                            <Box className={classes.reqCardBlock}>
                                <Box display="flex" alignItems="center" >
                                    <Avatar variant="square" className={classes.resimg} {...stringAvatar(subTitle)} />
                                    <Box flexGrow={1} marginInlineStart="12px">
                                        <Typography className={classes.Name}>{subTitle}</Typography>
                                        <Box height="2px" />
                                        <Typography noWrap className={classes.mobileNo}>{subTitle1}</Typography>
                                    </Box>


                                </Box>
                            </Box>
                            <Box mt={2}>
                                <Grid container spacing={2}>
                                    <Grid item xs={3}>
                                        <Typography className={classes.siteText}>Category</Typography>
                                        <Typography className={classes.listsubText}>site Visit</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={classes.siteText}>Purpose</Typography>
                                        <Typography className={classes.listsubText}>Residential</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={classes.siteText}>Start Date</Typography>
                                        <Typography className={classes.listsubText}>7th Dec</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={classes.siteText}>Priority</Typography>
                                        <Typography className={classes.listsubText}>Urgent</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className={classes.siteText}>Location</Typography>
                                        <Typography className={classes.listsubText}>Chennai</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className={classes.siteText}>Note</Typography>
                                        <Typography className={classes.listsubText}>site Visit</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        :
                        <Box style={{ height: size?.height - 200, overflow: "auto" }}>
                            <ViewServiceRequest t={t} value={maintenanceData}
                                request={"Maintenance"} />
                        </Box>

                }

            />
            <Drawer
                anchor={"right"}
                open={reAssignModal}
                onClose={() => setReAssignModal(false)}
            >
                <ReAssignModal
                    header={"Re-Assign Resouurce"}
                    agreement_inspection_id={agreement_inspection_id}
                    reassign={true}
                    moduleName={"Service Inspection"}
                    handleClose={() => setReAssignModal(false)}
                    buttonName={"Re-Assign"}
                    onSubmit={reAssign}
                />

            </Drawer>
        </Box>
    )
}